export enum AppRole {
  ADMIN = 'Адміністратор',
  HEAD = 'Керівник проєктів',
  DIRECTOR = 'Директор',
  MANAGER = 'Менеджер'
}
